import moment from 'moment-timezone'
import { createAction, handleActions } from 'redux-actions'
import $ from 'jquery'
import { populatePopupError, resetRoomBookingState } from '../actions'
import { destroy } from 'redux-form'
import { populateFormErrors } from './errorDialogModule'
import { createSelector } from 'reselect'
import { isAuthenticatedSelector } from '../selectors/authSelector'
import { getBookableDates } from '../../logic/bookableDatesLogic'
import {
  constrainDate,
  dateToString,
  parseDate,
  daysBetween
} from '../../utils/dateUtils'
import {
  allowMultipleBookings,
  getProgramDetails
} from '../../logic/programBookingLogic'
import history from '../../history'

export const _changeSearchParam = createAction('CHANGE_SEARCH_PARAM')
export const resetSearchParams = createAction('RESET_SEARCH_PARAMS')
export const _clearRoomSearchResults = createAction(
  'CLEAR_ROOMS_SEARCH_RESULTS'
)

export const validateTnc = () => {
  return (dispatch, getState) => {
    const {
      common: {
        authentication: { authenticated }
      },
      roomSearch: {
        params: { acceptedTC }
      }
    } = getState()

    return new Promise((resolve, reject) => {
      if (!authenticated && !acceptedTC) {
        dispatch(
          populateFormErrors({
            messages: [
              'In order to stay at Isha Institute of Inner-sciences, ' +
                'you must agree to the terms and conditions on this page'
            ],
            popupError: true
          })
        )

        reject(new Error('Terms and conditions not accepted'))
      } else {
        resolve()
      }
    })
  }
}

export function clearRoomSearchResults() {
  return dispatch => {
    dispatch(destroy('roomSelection'))
    dispatch(_clearRoomSearchResults())
  }
}

export function changeSearchParam(payload) {
  return dispatch => {
    dispatch(_changeSearchParam(payload))
    if (
      payload.name &&
      (payload.name === 'checkInDate' || payload.name === 'checkOutDate')
    ) {
      dispatch(clearRoomSearchResults())
    }
  }
}

export function setTime(payload) {
  return (dispatch, getState) => {
    const state = getState()
    let date =
      payload.name === 'checkInDate'
        ? checkInDateSelector(state)
        : checkOutDateSelector(state)
    date.set(payload.value)
    dispatch(changeSearchParam({ name: payload.name, value: date }))
  }
}

export function setProgramBooking({ isProgramBooking, program }) {
  return (dispatch, getState) => {
    dispatch(
      changeSearchParam({ name: 'isProgramBooking', value: isProgramBooking })
    )
    dispatch(changeSearchParam({ name: 'program', value: program }))

    const state = getState()
    const programBookingParams = bookableDatesSelector(state)
    dispatch(
      changeSearchParam({
        name: 'checkInDate',
        value: constrainDate(
          checkInDateSelector(state),
          programBookingParams.checkInMinDate,
          programBookingParams.checkInMaxDate
        )
      })
    )

    dispatch(
      changeSearchParam({
        name: 'checkOutDate',
        value: constrainDate(
          checkOutDateSelector(state),
          programBookingParams.checkOutMinDate,
          programBookingParams.checkOutMaxDate
        )
      })
    )

    if (programBookingParams.checkInTime) {
      dispatch(
        setTime({
          name: 'checkInDate',
          value: programBookingParams.checkInTime
        })
      )
    }

    if (programBookingParams.checkOutTime) {
      dispatch(
        setTime({
          name: 'checkOutDate',
          value: programBookingParams.checkOutTime
        })
      )
    }
  }
}

export function exitProgramBooking({ redirect }) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      console.log('Going back to regular booking')
      $.ajax({
        type: 'POST',
        url: '/api/program-booking/cancel',
        dataType: 'json',
        success: () => {
          dispatch(resetRoomBookingState())
          if (redirect) {
            history.push('/')
          }
          resolve()
        },
        error: (xhr, status, err) => {
          console.error('Error exiting program booking: ', err)
          dispatch(populatePopupError('An error occurred'))
          reject(err)
        }
      })
    })
  }
}

function getDefaultValue() {
  return {
    checkInDate: dateToString(
      moment()
        .startOf('hour')
        .hour(15)
    ),
    checkOutDate: dateToString(
      moment()
        .startOf('hour')
        .add(1, 'day')
        .hour(12)
    ),
    acceptedTC: false,
    isProgramBooking: false,
    program: null
  }
}

export const searchParamsReducer = handleActions(
  {
    CHANGE_SEARCH_PARAM: (state, action) => {
      let { name, value } = action.payload
      if (name === 'checkInDate' || name === 'checkOutDate') {
        value = dateToString(value)
      }
      return {
        ...state,
        [name]: value
      }
    },
    RESET_SEARCH_PARAMS: () => {
      return getDefaultValue()
    }
  },
  getDefaultValue()
)

function _roomSearchParamsSelector(state) {
  return state.roomSearch.params
}

export const checkInDateSelector = createSelector(
  _roomSearchParamsSelector,
  params => parseDate(params.checkInDate)
)
export const checkOutDateSelector = createSelector(
  _roomSearchParamsSelector,
  params => parseDate(params.checkOutDate)
)

/**
 * Exports selector with check in and out dates parsed as moment
 */
export const roomSearchParamsSelector = createSelector(
  _roomSearchParamsSelector,
  checkInDateSelector,
  checkOutDateSelector,
  (params, checkInDate, checkOutDate) => ({
    ...params,
    checkInDate,
    checkOutDate
  })
)

export function isProgramBookingSelector(state) {
  return _roomSearchParamsSelector(state).isProgramBooking
}

export function programSelector(state) {
  return _roomSearchParamsSelector(state).program
}

export const bookableDatesSelector = createSelector(
  isAuthenticatedSelector,
  isProgramBookingSelector,
  programSelector,
  (isAuthenticated, isProgramBooking, program) =>
    getBookableDates({ isAuthenticated, isProgramBooking, program })
)

export const programDetailsSelector = createSelector(
  programSelector,
  getProgramDetails
)

export const allowMultipleBookingsSelector = createSelector(
  programSelector,
  isAuthenticatedSelector,
  allowMultipleBookings
)

export const guestRequirementsSelector = createSelector(
  programDetailsSelector,
  (programDetails = {}) => {
    const {
      minAge = 7,
      minAdultAge = 14,
      childrenAllowed = true,
      roomType,
      minStudioGuests = 1
    } = programDetails
    return {
      minAge,
      minAdultAge,
      childrenAllowed,
      programRoomType: roomType,
      minStudioGuests
    }
  }
)

export const numDaysSelector = createSelector(
  checkInDateSelector,
  checkOutDateSelector,
  daysBetween
)



// WEBPACK FOOTER //
// ./src/redux/modules/searchParamsModule.js